import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'linie/';

export default {

    getLinie() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    addLinia(data) {
        return axios({
            method: 'post',
            url: URL,
            data: JSON.stringify(data),
        })
    },

    editLinia(id, data) {
        return axios(
            {
                url: URL + id,
                method: 'put',
                data: JSON.stringify(data),
            }
        )
    },

    deleteLinia(id) {
        return axios({
                url: URL + id,
                method: 'delete',
            }
        )
    },
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/linie/LinieService.js